import React, { useState, useEffect } from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import EscaneoCamara from "../../components/escaneos/EscaneoCamara";
import FormEscaneos from "../../components/escaneos/FormEscaneos";
import useEscaneosStore from "../../store/escaneosStore";
import { useNavigate, useParams } from "react-router-dom";

const DetalleEscaneoPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { isLoading, iniciar, setNavigate, actualizarId, datos } = useEscaneosStore();
  
  useEffect(() => {
    setNavigate(navigate);
    actualizarId(id);
    iniciar();
  }, []);

  return (
    <MasterLayout>
      {
        datos.id != 0 ? <FormEscaneos/> : <EscaneoCamara/>
      }
    </MasterLayout>
  );
};

export default DetalleEscaneoPage;
